import React, { useEffect, useState, forwardRef, useRef } from "react";
import { getProductCategoryDetailsAPI } from "../../../../Store/Action/productCategory";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// import "./styles.css";
import "./styles.css";

// Wrap the component with forwardRef
const SubcategoriesByCategory = forwardRef((props, ref) => {
  const { setHovering, setCategoriesLoaded, productCategory } = props; // Access the prop here
  const [subcategoryPosition, setSubcategoryPosition] = useState({
    left: 0,
    top: 0,
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [categories, setProductCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null); // Track selected category
  const [selectedSubCategory, setSelectedSubCategory] = useState(null); // Track selected subcategory
  const [hoveredCategory, setHoveredCategory] = useState(null); // Hovered category state
  const [hoveredSubCategory, setHoveredSubCategory] = useState(null); // Hovered subcategory state

  useEffect(() => {
    setProductCategory(productCategory);
  }, [productCategory]);

  // useEffect(() => {
  //   const productPurityAPI = async () => {
  //     try {
  //       const params = {
  //         searchQuery: null,
  //         page: null,
  //         limit: null,
  //       };

  //       dispatch(
  //         getProductCategoryDetailsAPI(params, (result) => {
  //           setProductCategory(result?.data || []);
  //           setCategoriesLoaded(true); // Set only if data exists
  //         })
  //       );
  //     } catch (error) {
  //       console.log("Failed to fetch categories:", error);
  //     }
  //   };
  //   productPurityAPI();
  // }, [dispatch]);

  // useEffect(() => {
  //   const fetchCategories = async () => {
  //     dispatch(
  //       getProductCategoryDetailsAPI({}, (result) => {
  //         if (result?.data?.length > 0) {
  //           setProductCategory(result.data);
  //           setCategoriesLoaded(true); // ✅ Set this BEFORE user hovers
  //         } else {
  //           setCategoriesLoaded(false);
  //         }
  //       })
  //     );
  //   };

  //   fetchCategories();
  // }, [dispatch]); // ✅ No need to add `setCategoriesLoaded` in dependencies

  const handleCategoryClick = (category) => {
    // setSelectedCategory(category);
    setSelectedSubCategory(null);
  };
  const openSubCategorMenu = (category) => {
    setSelectedCategory(category);
  };
  const handleSubCategoryClick = (subcategory) => {
    setSelectedSubCategory(subcategory);
    navigate("/sub-categories", {
      state: { subCategories: [subcategory], fromSubCatDropdown: true }, // Pass subcategories through state
    });
  };

  const categoryRefs = useRef({});

  // const handleCategoryHover = (category, event) => {
  //   setHoveredCategory(category.product_category_id);
  //   setSelectedCategory(category);

  //   // Get the position of the hovered category
  //   const rect = event.target.getBoundingClientRect();

  //   setSubcategoryPosition({
  //     left: 201, // Position slightly to the right
  //     // top: rect.top - 160 + window.scrollY, // Align vertically
  //     top: rect.top - 170, // Align vertically
  //   });
  // };

  // const handleCategoryHover = (category, event) => {
  //   setHoveredCategory(category.product_category_id);
  //   setSelectedCategory(category);

  //   const rect = event.target.getBoundingClientRect();
  //   const dropdownHeight = category.product_sub_category?.length * 40 || 200; // Estimate height or use ref later
  //   const windowHeight = window.innerHeight;

  //   // let calculatedTop = rect.top - 160 + window.scrollY;
  //   let calculatedTop = rect.top - 160;
  //   if (rect.top + dropdownHeight > windowHeight) {
  //     // If it would overflow, shift upward
  //     calculatedTop = windowHeight - dropdownHeight - 20; // Add some margin
  //     if (calculatedTop < 0) calculatedTop = 0; // Prevent going too high
  //   }

  //   setSubcategoryPosition({
  //     left: 201,
  //     top: calculatedTop,
  //   });
  // };
  // const handleCategoryHover = async (category, event) => {
  //   setHoveredCategory(category.product_category_id);
  //   setSelectedCategory(category);

  //   const rect = event.target.getBoundingClientRect();

  //   // 1️⃣ Fetch subcategories when hovering
  //   dispatch(
  //     getProductCategoryDetailsAPI(
  //       { product_category_id: category.product_category_id },
  //       (result) => {
  //         const subcats = result?.data?.[0]?.product_sub_categories || [];

  //         setSelectedCategory((prev) =>
  //           prev?.product_category_id === category.product_category_id
  //             ? { ...prev, product_sub_categories: subcats }
  //             : prev
  //         );
  //       }
  //     )
  //   );

  //   // 2️⃣ Dropdown positioning logic
  //   const dropdownHeight =
  //     (selectedCategory.product_sub_categories?.length || 5) * 40;
  //   const windowHeight = window.innerHeight;

  //   let calculatedTop = rect.top - 160;
  //   if (rect.top + dropdownHeight > windowHeight) {
  //     calculatedTop = windowHeight - dropdownHeight - 20;
  //     if (calculatedTop < 0) calculatedTop = 0;
  //   }

  //   setSubcategoryPosition({
  //     left: 201,
  //     top: calculatedTop,
  //   });
  // };

  // const handleCategoryHover = (category, event) => {
  //   setHoveredCategory(category.product_category_id);

  //   // Set base category first
  //   setSelectedCategory({ ...category, product_sub_categories: [] });

  //   const rect = event.target.getBoundingClientRect();

  //   // Fetch subcategories using your correct param
  //   dispatch(
  //     getProductCategoryDetailsAPI(
  //       { product_category_id: category.product_category_id },
  //       (result) => {
  //         const subcats = result?.data?.[0]?.product_sub_categories || [];

  //         // Update only if user is still hovering same category
  //         setSelectedCategory((prev) =>
  //           prev?.product_category_id === category.product_category_id
  //             ? { ...prev, product_sub_categories: subcats }
  //             : prev
  //         );
  //       }
  //     )
  //   );

  //   // Use selectedCategory instead of category for height
  //   const dropdownHeight =
  //     (selectedCategory?.product_sub_categories?.length || 5) * 40;
  //   const windowHeight = window.innerHeight;

  //   let calculatedTop = rect.top - 160;

  //   if (rect.top + dropdownHeight > windowHeight) {
  //     calculatedTop = windowHeight - dropdownHeight - 20;
  //     if (calculatedTop < 0) calculatedTop = 0;
  //   }

  //   setSubcategoryPosition({
  //     left: 201,
  //     top: calculatedTop,
  //   });
  // };
  // const handleCategoryHover = (category, event) => {
  //   setHoveredCategory(category.product_category_id);

  //   // ✔ Keep previous category
  //   setSelectedCategory(category);

  //   const rect = event.target.getBoundingClientRect();

  //   // 👉 Call API but DO NOT clear subcategories
  //   dispatch(
  //     getProductCategoryDetailsAPI(
  //       { product_category_id: category.product_category_id },
  //       (result) => {
  //         const subcats = result?.data?.[0]?.product_sub_categories || [];

  //         // ✔️ Only update subcategories after API returns
  //         setSelectedCategory((prev) => ({
  //           ...prev,
  //           product_sub_categories: subcats,
  //         }));
  //       }
  //     )
  //   );

  //   // dropdown positioning
  //   const dropdownHeight = (category.product_sub_categories?.length || 5) * 40;
  //   const windowHeight = window.innerHeight;

  //   let calculatedTop = rect.top - 160;
  //   if (rect.top + dropdownHeight > windowHeight) {
  //     calculatedTop = windowHeight - dropdownHeight - 20;
  //     if (calculatedTop < 0) calculatedTop = 0;
  //   }

  //   setSubcategoryPosition({
  //     left: 201,
  //     top: calculatedTop,
  //   });
  // };
  const handleCategoryHover = (category, event) => {
    setHoveredCategory(category.product_category_id);

    // mark selected category but set subcategories to null (means: fetching)
    setSelectedCategory({ ...category, product_sub_categories: null });

    const rect = event.target.getBoundingClientRect();

    dispatch(
      getProductCategoryDetailsAPI(
        { product_category_id: category.product_category_id },
        (result) => {
          const subcats = result?.data?.[0]?.product_sub_categories || [];

          // only update if same category still selected (prevents race)
          setSelectedCategory((prev) =>
            prev?.product_category_id === category.product_category_id
              ? { ...prev, product_sub_categories: subcats }
              : prev
          );
        }
      )
    );

    // compute dropdown height using selectedCategory (fallback to estimate)
    const dropdownCount = selectedCategory?.product_sub_categories?.length ?? 5;
    const dropdownHeight = dropdownCount * 40;
    const windowHeight = window.innerHeight;

    let calculatedTop = rect.top - 160;
    if (rect.top + dropdownHeight > windowHeight) {
      calculatedTop = windowHeight - dropdownHeight - 20;
      if (calculatedTop < 0) calculatedTop = 0;
    }

    setSubcategoryPosition({
      left: 201,
      top: calculatedTop,
    });
  };

  return (
    <div
      ref={ref}
      className="dropdownStyle"
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      <div style={{ position: "relative" }}>
        {/* First Section: Category List */}
        <ul className="categoryList">
          {categories.map((category) => (
            <li
              key={category.product_category_id}
              ref={(el) =>
                (categoryRefs.current[category.product_category_id] = el)
              }
              onClick={() => handleCategoryClick(category)} // Category click handler
              // onMouseEnter={() => {
              //   setHoveredCategory(category.product_category_id);
              //   openSubCategorMenu(category);
              //   // handleCategoryClick(category);
              // }}
              onMouseEnter={(event) => handleCategoryHover(category, event)}
              onMouseLeave={() => setHoveredCategory(null)}
              className={`categoryItem ${
                selectedCategory?.product_category_id ===
                category.product_category_id
                  ? "selectedCategory"
                  : hoveredCategory === category.product_category_id
                  ? "hoveredCategory"
                  : ""
              }`}
            >
              {category.product_category_name}
            </li>
          ))}
        </ul>

        {/* Second Section: Subcategory List */}
        {selectedCategory &&
          selectedCategory.product_sub_categories !== null && (
            <div
              className="subcategoryDropdown"
              style={{
                position: "absolute",
                // left: `${subcategoryPosition.left}px`,
                top: `${subcategoryPosition.top}px`,
              }}
            >
              {/* {selectedCategory.product_sub_categories &&
            selectedCategory.product_sub_categories.length > 0 ? ( */}
              {selectedCategory.product_sub_categories ===
              null ? null : selectedCategory.product_sub_categories && // still fetching — show nothing
                selectedCategory.product_sub_categories.length > 0 ? (
                <ul>
                  {selectedCategory.product_sub_categories.map(
                    (subcategory, index) => (
                      <li
                        key={index}
                        onClick={() => handleSubCategoryClick(subcategory)} // Handle subcategory click
                        onMouseEnter={() =>
                          setHoveredSubCategory(subcategory.product_category_id)
                        } // Hover effect for subcategory
                        onMouseLeave={() => setHoveredSubCategory(null)}
                        className={`categoryNameText ${
                          selectedSubCategory?.product_category_id ===
                          subcategory.product_category_id
                            ? "selectedSubCategory"
                            : hoveredSubCategory ===
                              subcategory.product_category_id
                            ? "hoveredSubCategory"
                            : ""
                        }`}
                      >
                        {subcategory.product_category_name}
                      </li>
                    )
                  )}
                </ul>
              ) : (
                <p className="noDataText">No Data Found</p>
              )}
            </div>
          )}
      </div>
    </div>
  );
});

export default SubcategoriesByCategory;
